class DialogEvent {
	static get CLOSE(){
		return "dialog_event_close";
	}

}
export {DialogEvent}